import { portNumbers } from "get-port"
import type { Infra } from "./toEcosystem"
import { getFreePort } from "./utils"

export type toMeeNodeParameters = {
  infras: Infra[]
}
export type MeeNode = Awaited<ReturnType<typeof toMeeNode>>
export const toMeeNode = async ({ infras }: toMeeNodeParameters) => {
  const port = await getFreePort(5999, 5990)
  const chainIds = infras.map((infra) => infra.network.chainId)
  return {
    chainIds,
    url: `http://127.0.0.1:${port}`
  }
}
